import axios from "axios";
import { REACT_APP_WUCA_DXP_API_BEARER_TOKEN, REACT_APP_WUCA_DXP_ADMIN_URL } from "./config";

export async function getAllResources(assetAliasPath: string
): Promise<any> {
    const authToken = (sessionStorage.getItem("authToken") || "");
    // console.log("Fetching all Resources with assetAliasPath:", assetAliasPath);
    // console.log("Auth Token:", authToken);

    const response = axios
        .get(
            `${REACT_APP_WUCA_DXP_ADMIN_URL}api/v1/resource?aliasPath=/${assetAliasPath}`, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                "X-API-KEY": REACT_APP_WUCA_DXP_API_BEARER_TOKEN, // Replace with your actual API key if needed
            },
        })
    return response;

}

export async function getResourceById(resourceId: string, ct: string, cd: string): Promise<any> {
    const authToken = (sessionStorage.getItem("authToken") || "");

    // console.log("Fetching document by ID:", resourceId);
    const response = axios
        .get(`${REACT_APP_WUCA_DXP_ADMIN_URL}/api/v1/resource/${resourceId}?contentType=${ct}&ContentDisposition=${cd}`, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                "X-API-KEY": REACT_APP_WUCA_DXP_API_BEARER_TOKEN, // Replace with your actual API key if needed
            },
        })
    return response;
}

export async function getAllRoles(): Promise<any> {
    const authToken = (sessionStorage.getItem("authToken") || "");
    // console.log("Auth Token:", authToken);

    const response = axios
        .get(
            `${REACT_APP_WUCA_DXP_ADMIN_URL}api/v1/roles/dashboardsbyuserroles`, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                "X-API-KEY": REACT_APP_WUCA_DXP_API_BEARER_TOKEN, // Replace with your actual API key if needed
            },
        })
    return response;

}